/**
 * @param rangeMin - The minimum range
 * @param rangeMax - The maximum range
 * @param scale - The scale (e.g. 5, 10, 1)
 * @returns The display values (e.g. [0, 5, 10, 15, 20])
 */
export const getDisplayValues = (
  rangeMin: number,
  rangeMax: number,
  scale: number,
): Array<number> => {
  const length = Math.floor((rangeMax - rangeMin) / scale) + 1;
  return Array.from({ length }, (_, i) => rangeMin + i * scale);
};
